import { DirectUpload } from '@rails/activestorage';
import { REACT_APP_BACKEND_API_URL } from '../../../../Constants';
import { setUploadAction, setProgressAction, setErrorAction } from './directUpload.actions';
const getAuthHeaders = () => {
    const headers = {};
    const adminToken = sessionStorage.getItem('admin_token');
    const adminEmail = sessionStorage.getItem('email');
    const authToken = sessionStorage.getItem('agencyAuthToken');
    if (adminToken)
        headers['X-Admin-Token'] = adminToken;
    if (adminEmail)
        headers['X-Admin-Email'] = adminEmail;
    if (authToken)
        headers['Authorization'] = `Bearer ${authToken}`;
    return headers;
};
export const uploadFile = (key, file) => async (dispatch) => {
    dispatch(setUploadAction(key, {
        status: 'uploading',
        progress: 0,
        signedId: null,
        previewUrl: null,
        fileName: null,
        error: null
    }));
    try {
        const directUploadUrl = `${REACT_APP_BACKEND_API_URL}/direct_uploads`;
        const headers = getAuthHeaders();
        const delegate = {
            directUploadWillStoreFileWithXHR: (xhr) => {
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const progress = Math.round((event.loaded / event.total) * 100);
                        dispatch(setProgressAction(key, progress));
                    }
                });
            }
        };
        const upload = new DirectUpload(file, directUploadUrl, delegate, headers);
        const blob = await new Promise((resolve, reject) => {
            upload.create((error, blob) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(blob);
                }
            });
        });
        dispatch(setUploadAction(key, {
            status: 'complete',
            progress: 100,
            signedId: blob.signed_id,
            previewUrl: blob.url,
            fileName: blob.filename
        }));
        return blob.signed_id;
    }
    catch (error) {
        const message = error instanceof Error ? error.message : 'Upload failed';
        dispatch(setErrorAction(key, message));
        throw error;
    }
};
